<template>
  <div class="bbe-drop-files"
       :class="{'bbe-drop-files_show': visibility && !draggedTemplate.start}"
       ref="bbeDropArea">
    <i class="email-icon-up-arrow bbe-drop-files__icon"/>
    <span class="bbe-drop-files__text">
        Drop your files and upload
      </span>
  </div>
</template>

<script>

export default {
  name: 'DropFiles',
  props: ['visibility'],
  computed: {
    draggedTemplate () {
      return this.$store.getters.draggedTemplate
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-drop-files {
    @include global-font;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($color-alabaster, 0.7);
    border: 1px dashed $color-accent;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: .3s;
    pointer-events: none;

    &_show {
      z-index: 1;
      opacity: 1;
    }

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 34px;
      height: 34px;
      background: $color-accent;
      border-radius: 50%;
      color: $color-white;
      font-size: 14px;
    }

    &__text {
      margin-top: 13px;
      color: $color-gray;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/DropFiles/DropFiles.vue